export default "__VITE_ASSET__D0b88g_H__"